import { RouteObject } from 'react-router-dom';

import MaterialRequisition from '@Features/MaterialRequest/requests/MaterialRequisition/MaterialRequisition';
import ManageRequests from '@Features/MaterialRequest/ManageRequests/ManageRequests';
import TaskList from '@Features/MaterialRequest/TaskList/TaskList';
import Procurement from '@Features/MaterialRequest/Procurement/Procurement';
import PurchaseRequest from '@Features/MaterialRequest/requests/PurchaseRequest/PurchaseRequest';
import TenderRequest from '@Features/MaterialRequest/requests/TenderRequest/TenderRequest';
import TenderConfirmScreen from '@Features/MaterialRequest/requests/TenderRequest/form/Confirm/TenderConfirmScreen';

import {
  MaterialRequisitionCreateForm,
  MaterialRequisitionEditForm,
  MaterialConfirmScreen,
} from '@Features/MaterialRequest/requests/MaterialRequisition/form';
import ProfilePage from '@Pages/ProfilePage/ProfilePage';
import ProfileDetails from '@Pages/ProfilePage/ProfileDetails/ProfileDetails';

import { ApprovalFormResolver } from '@Features/MaterialRequest/ApprovalFormResolver';

import { PurchaseRequestCreateForm } from '@Features/MaterialRequest/requests/PurchaseRequest/form';
import PreviousPricing from '@Features/MaterialRequest/requests/TenderRequest/form/PreviousPricing/PreviousPricing';
import { ComparisonSheetScreen } from '@Features/MaterialRequest/requests/TenderRequest/form/ComparisonSheet/ComparisonSheetScreen';

import {
  MaterialsTab,
  SelectedTab,
  ApproveTab,
} from '@Features/MaterialRequest/requests/TenderRequest/form/ComparisonSheet/TabSwitch/tabs';
import MRFeatureRoutePath from './MRFeatureRoutePath.enum';

const featureMRRouter: RouteObject[] = [
  {
    path: '/mr',
    children: [
      {
        path: MRFeatureRoutePath.MANAGE_REQUESTS,
        element: <ManageRequests />,
        children: [
          {
            path: MRFeatureRoutePath.MANAGE_REQUEST_MATERIAL_REQUEST,
            element: <MaterialRequisition />,
            children: [
              {
                path: MRFeatureRoutePath.MANAGE_REQUEST_CREATE_MATERIAL_REQUEST,
                element: <MaterialRequisitionCreateForm />,
              },
              {
                path: MRFeatureRoutePath.MANAGE_REQUEST_EDIT_MATERIAL_REQUEST,
                element: <MaterialRequisitionEditForm />,
              },
              {
                path: MRFeatureRoutePath.MANAGE_REQUEST_CONFIRM_REQUEST,
                element: <MaterialConfirmScreen />,
              },
            ],
          },
        ],
      },
      {
        path: MRFeatureRoutePath.APPROVALS,
        element: <TaskList />,
        children: [
          {
            path: MRFeatureRoutePath.TASK_APPROVE_REQUEST,
            element: <ApprovalFormResolver />,
          },
        ],
      },
      {
        path: MRFeatureRoutePath.PROCUREMENT,
        element: <Procurement />,
        children: [
          {
            path: MRFeatureRoutePath.PROCUREMENT_PURCHASE_REQUEST,
            element: <PurchaseRequest />,
            children: [
              {
                path: MRFeatureRoutePath.PROCUREMENT_CREATE_TENDER_REQUEST,
                element: <PurchaseRequestCreateForm />,
              },
              {
                path: MRFeatureRoutePath.PROCUREMENT_CONFIRM_TENDER_REQUEST,
                element: <TenderConfirmScreen />,
              },
            ],
          },
          {
            path: MRFeatureRoutePath.PROCUREMENT_TENDER_REQUEST,
            element: <TenderRequest />,
            children: [
              {
                path: MRFeatureRoutePath.PREVIOUS_PRICING,
                element: <PreviousPricing />,
              },
              {
                path: MRFeatureRoutePath.COMPARISON_SHEET,
                element: <ComparisonSheetScreen />,
                children: [
                  {
                    path: MRFeatureRoutePath.COMPARISON_SHEET_MATERIALS,
                    element: <MaterialsTab />,
                  },
                  {
                    path: MRFeatureRoutePath.COMPARISON_SHEET_SELECTED,
                    element: <SelectedTab />,
                  },
                  {
                    path: MRFeatureRoutePath.COMPARISON_SHEET_APPROVE,
                    element: <ApproveTab />,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: MRFeatureRoutePath.PROFILE,
        element: <ProfilePage />,
        children: [
          {
            path: MRFeatureRoutePath.PROFILE_DETAILS,
            element: <ProfileDetails />,
          },
        ],
      },
    ],
  },
];

export default featureMRRouter;
